import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import SimpleDataTable from "lib/components/common/simple-data-table";
import useMembershipPackages from "lib/hooks/useMembershipPackages";
import MembershipPackageDetails from "./membership-package-details";
import LoadingBox from "lib/components/common/loading-box";
import { MEMBERSHIP_PACKAGES_COLUMNS } from "lib/constants/table-columns";

const MembershipPackages = () => {
  const [selectedPackage, setSelectedPackage] = useState<MembershipPackage>(null);
  const {
    membershipPackages,
    getMembershipPackages,
    loading,
    error,
    updateMembershipPackage,
    addMembershipPackage,
    deleteMembershipPackage,
    resetError,
  } = useMembershipPackages();

  useEffect(() => {
    getMembershipPackages();
  }, []);

  const handleAddPackage = async (membershipPackages: MembershipPackage) => {
    addMembershipPackage(membershipPackages, (newPackage) => {
      setSelectedPackage(null);
      getMembershipPackages();
    });
  };

  const handleUpdateMembershipPackage = (membershipPackages: MembershipPackage) => {
    updateMembershipPackage(membershipPackages, (updatedPackage) => {
      setSelectedPackage(null);
      getMembershipPackages();
    });
  };

  const handleDeletePackage = (packageId: string) => {
    if (window.confirm("Are you sure you want to delete this membership package?")) {
      deleteMembershipPackage(packageId, () => {
        setSelectedPackage(null);
        getMembershipPackages();
      });
    }
  };

  const handlePackageSelection = (membershipPackages?: MembershipPackage) => {
    if (membershipPackages) {
      setSelectedPackage(membershipPackages);
    } else {
      setSelectedPackage({} as MembershipPackage);
    }
  };

  if (loading) return <LoadingBox message="Processing your request" />;

  if (selectedPackage) {
    return (
      <MembershipPackageDetails
        error={error}
        isLoading={loading}
        updateMembershipPackage={handleUpdateMembershipPackage}
        addMembershipPackage={handleAddPackage}
        deleteMembershipPackage={handleDeletePackage}
        membershipPackageData={selectedPackage}
        onCancelClick={() => {
          resetError();
          setSelectedPackage(null);
        }}
      />
    );
  }

  return (
    <>
      <SimpleDataTable
        isLoading={loading}
        error={error}
        columns={MEMBERSHIP_PACKAGES_COLUMNS}
        data={membershipPackages}
        title="Membership Packages"
        action={
          <Button onClick={() => handlePackageSelection()}>Add Membership Package</Button>
        }
        onRowClick={handlePackageSelection}
      />
    </>
  );
};

export default MembershipPackages;